module.exports = __webpack_public_path__ + "static/img/win6.b0bb58a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/win6.png
// module id = aANK
// module chunks = 0